export const SNAPSHOT_ROOT = 'snapshot-root';
export const SNAPSHOT_ROOT_FRAME = 'snapshot-root-frame';
